// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3EFY5","productName":"Table_productName__3O7zm"};